export interface FormDataSimplified {
  sectionName?: string;
  sectionFromGroup?: string;
  sectionFormArray?: string;
  showToggle?: boolean;
  showNotes?: string;
  disabled?: boolean;
  fields?: fieldSimplified[];
}

export interface fieldSimplified {
  name?: string;
  type?: FieldTypeEnumSimplified;
  label?: string;
  value?: any;
  required?: boolean;
  download?: boolean;
  width?: FieldWidthEnumSimplified;
  options?: FieldOptionsSimplified[];
  imagePlaceHolder?: string | string[];
  isProfileImage?: boolean;
  originalOptionGroups?: optionsGroup[];
  optionGroups?: optionsGroup[];
  disabled?: boolean;
  pattern?: string;
  hidden?: boolean;
  suggested?: boolean;
  reference?: string;
  formGroup?: boolean;
  fields?: fieldSimplified[];
  shouldRestrictDate?: boolean
}

export interface optionsGroup {
  title?: string;
  disabled?: false;
  autoSelect?:boolean;
  fields?: FieldOptionsSimplified[];
  icon?: string;
}

export enum FieldWidthEnumSimplified {
  FULLWIDTH = 'FULLWIDTH',
  HALFWIDTHRIGHT = 'HALFWIDTHRIGHT',
  HALFWIDTHLEFT = 'HALFWIDTHLEFT',
}

export enum FieldTypeEnumSimplified {
  TEXT = 'text',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  COLOR = 'color',
  DATE = 'date',
  EMAIL = 'email',
  PASSWORD = 'password',
  FILE = 'file',
  RADIO = 'radio',
  RANGE = 'range',
  RESET = 'reset',
  SEARCH = 'search',
  TEL = 'tel',
  URL = 'url',
  SELECTGROUP = 'SELECTGROUP',
  SELECTGROUPAUTOCOMPLETE = 'SELECTGROUPAUTOCOMPLETE',
  OTHERSELECT = 'OTHERSELECT',
  COMMENT = 'COMMENT',
  TIME = 'TIME',
  COMMENT_INPUT = 'COMMENT_INPUT',
  COUNTRY_CODE = 'COUNTRY_CODE',
  DATE_RANGE = 'DATE_RANGE',
  SLIDE = 'SLIDE',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
    AUTOCOMPLETE1 = 'AUTOCOMPLETE1',

  MULTIPLE_FILE = 'MULTIPLE_FILE',
  NATIONALITY = 'NATIONALITY',
  GROUPEDMULTISELECTCOMPONENT = 'GROUPEDMULTISELECTCOMPONENT',
  MULTIPLE_SELECT_OPTION = 'MULTIPLE_SELECT_OPTION',
}

export interface FieldOptionsSimplified {
  key?: string;
  value?: string | boolean | number | object | Array<any>;
  disabled?: boolean;
  icons?:string[]
}
